module.exports = __webpack_public_path__ + "img/AddProfilePicture.829853bc.svg";